// import React from 'react';
// import AudioPlayer2 from 'react-custom-audio-player';


// const AudioPlayer = ({ audioData }) => {

//     return (
//         <div>
//             <input type="checkbox" id="my-modal-6" class="modal-toggle" />
//             <div class="modal modal-bottom sm:modal-middle">
//                 <div class="modal-box">
//                     <h3 class="font-bold text-lg">{audioData?.name} {audioData?.date}</h3>
//                     <AudioPlayer2 src={audioData?.link} />
//                     {/* <audio className='mx-auto mt-4' src={audioData?.link} controls autoPlay></audio> */}
//                     <div class="modal-action">
//                         <label for="my-modal-6" class="btn btn-sm btn-circle btn-accent font-bold text-3xl text-white absolute right-2 top-2"><svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
//                             <path strokeLinecap="round" strokeLinejoin="round" d="M20 12H4" />
//                         </svg></label>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default AudioPlayer;


import React, { useRef, useState } from 'react';
import 'react-h5-audio-player/lib/styles.css';
import AudioPlayer from 'react-h5-audio-player';
import './OnlineAudioPlayer.css';
import { FaPlay, FaPause } from 'react-icons/fa';

const OnlineAudioPlayer = ({ audioData }) => {
    const [isPlaying, setIsPlaying] = useState(true);


    const handlePlayPause = () => {
        // Just toggle the play/pause state, since AudioPlayer handles the actual playing and pausing
        setIsPlaying(!isPlaying);
      };

    console.log('Online Playing');
    return (
        <div>
            <input type="checkbox" id="my-modal-6" className="modal-toggle" />
            <div className="modal modal-bottom sm:modal-middle">
                <div className="modal-box online-modal-box">
                    {/* Marquee effect for name and date */}
                    <div className="online-marquee-container">
                        <p>{audioData?._id ? 'Online Player' : <span className='text-xl'>Live</span>}</p>
                        <span className="online-marquee-text">
                           {audioData?.mainCategory==="kobita"?`${audioData?.writer} এর লিখিত কবিতা- ${audioData?.name},
                            লেখার তারিখ- ${audioData?.date_time}, ${audioData?.singer} এর কণ্ঠে`:audioData?.mainCategory==="boyan"?
                            `হজরত মাওলানা মুফতি শাহ্‌ শফী সাহেব দাঃবাঃ এর ${audioData?.category} - ${audioData?.name}, তারিখ- ${audioData?.date}`:
                            audioData?.mainCategory==="answers"?`হজরত মাওলানা মুফতি শাহ্‌ শফী সাহেব দাঃবাঃ এর ${audioData?.category} 
                            বিষয়ে প্রশ্ন-উত্তর -${audioData?.question}`: !audioData?._id ?`জরত মাওলানা মুফতি শাহ্‌ শফী সাহেব দাঃবাঃ এর বয়ানের সরাসরি সম্প্রচার`: `হজরত মাওলানা মুফতি শাহ্‌ শফী সাহেব দাঃবাঃ এর ${audioData?.name} সম্পর্কে ছোট বয়ান`}
                        </span>
                    </div>

                    {/* Stylish Audio Player */}
                    <AudioPlayer
                        // className={`${audioData?._id ? '' : 'invisible absolute w-0 h-0'}`}
                        autoPlay
                        src={audioData?._id ? audioData?.link : audioData}
                        onPlay={() => setIsPlaying(true)} // When the audio starts, set it to playing
                        onPause={() => setIsPlaying(false)} // When the audio pauses, set it to paused
                    />
                    {/* <button
                        onClick={handlePlayPause}
                        className="play-pause-btn p-3 bg-blue-500 text-white rounded-full"
                    >
                        {isPlaying ? <FaPause onClick={()=>setAudioData(null)} /> : <FaPlay />}
                    </button> */}

                    {/* Modal Close Button */}
                    <div className="modal-action">
                        <label htmlFor="my-modal-6" className="btn btn-sm btn-circle btn-accent font-bold text-3xl text-white absolute right-2 top-2">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M20 12H4" />
                            </svg>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OnlineAudioPlayer;

